import Services, { services } from "./Services";
import agentImg from "../assets/dp.jpg"; // Make sure to add this image to your assets folder

const Hero = () => (
  <section className="relative h-screen w-screen overflow-hidden text-white">
    {/* Services Section */}

    <iframe
      className="absolute top-0 left-0 w-full h-full z-10"
      src="https://www.youtube-nocookie.com/embed/dDYEsuqGDcU?controls=0&rel=0&playsinline=1&autoplay=1&mute=1&loop=1&playlist=dDYEsuqGDcU"
      title="Modern House"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      style={{
        border: "none",
      }}
    ></iframe>

    <div className="relative z-10 h-full flex flex-col justify-center items-center bg-black bg-opacity-50 text-center px-4">
      <h1 className="text-4xl md:text-5xl font-bold font-custom flex items-center justify-center">
        <span>Devan</span>
        <div className="w-1 h-10 bg-brand mx-2"></div>
        {/* Custom color bar */}
        <span>Remax Realtor</span>
      </h1>
      <p className="mt-4 text-lg font-custom">
        I deliver the very best in all facets of real estate. Because you
        deserve no less.
      </p>
      <div className="mt-6 flex space-x-4">
        <a
          href="https://wa.me/16475504350?text=Hello%2C%20I%E2%80%99m%20interested%20in%20learning%20more%20about%20your%20real%20estate%20offerings.%20Can%20you%20help%20me%3F"
   target="_blank"
          rel="noopener noreferrer"
          
          className="px-6 py-2 bg-brand text-white rounded transition-colors duration-300 hover:bg-yellow-600 hover:text-gray-900 font-custom"
        >
          CONTACT ME
        </a>
        <a
          href="#listings"
          className="relative text-white flex items-center group font-custom"
        >
          <span className="relative z-10 transition-colors duration-300 group-hover:text-yellow-500">
            View Listings
          </span>
          <span className="absolute left-0 right-0 bottom-0 h-1 bg-white transform translate-y-1 transition-all duration-300 group-hover:bg-brand"></span>
          <ArrowIcon />
        </a>
      </div>

    </div>
  </section>
);

const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="ml-1" // Add margin-left for spacing
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M11.3 8.3a.5.5 0 0 1 0 .4l-4 4a.5.5 0 0 1-.8-.4V9H1.5a.5.5 0 0 1 0-1h5V4.1a.5.5 0 0 1 .8-.4l4 4z"
    />
  </svg>
);

export default Hero;
